import { TeaConfig } from './tea.model';

export const USER_DEFINED_TEA = -1;
export const USER_DEFINED_OPTION = { schema: 'User Defined', teaConfigId: USER_DEFINED_TEA } as TeaConfig;
export const NO_TEA = -2;
export const NONE_OPTION = { schema: 'None', teaConfigId: NO_TEA } as TeaConfig;

export const UNSAVED_MESSAGE = `There are unsaved changes in the form, would you like to navigate away?`;
export const UNSAVED_MESSAGE_REFRESH_DATA = `There are unsaved changes in the form, would you like to refresh data? If you refresh you will lose your changes.`;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/contracts/common/const.model.ts